import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateCustomerSchedulePackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateCustomerSchedulePackage = createAsyncThunk('updateCustomerSchedulePackage', async (payload) => {
  return await updateCustomerSchedulePackageApi(payload);
});

const updateCustomerSchedulePackageSlice = createSlice({
  name: 'updateCustomerSchedulePackage', // Unique Name
  initialState,
  reducers: {
    updateCustomerSchedulePackageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCustomerSchedulePackage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateCustomerSchedulePackage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateCustomerSchedulePackage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateCustomerSchedulePackageReset } = updateCustomerSchedulePackageSlice.actions;

export default updateCustomerSchedulePackageSlice.reducer;
